const PRIMARY_COLOR = '#a3b9c0';
const DARK_COLOR = '#585759';
const TEXT_COLOR = '#586b73';
const FONT_FAMILY = '"volte_roundedregular", sans-serif';

const theme = {
  primary: PRIMARY_COLOR,
  link: PRIMARY_COLOR,
  secondary: '#85a1a8',
  info: '#6d878d',
  danger: '#dc3545',
  warning: '#ffc107',
  success: '#28a745',
  light: '#f8f9fa',
  dark: DARK_COLOR,
  textColor: TEXT_COLOR,
  headingsColor: TEXT_COLOR,
  secondaryBackground: '#f9fafa',

  fontFamily: FONT_FAMILY,
  headingsFontFamily: FONT_FAMILY
};

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js